export default {
  identificationTypes: [],
};
